<h2 mat-dialog-title>Verificar código de atendimento</h2>
<mat-dialog-content [formGroup]="paymentCodeForm">
  <page-alert
    *ngIf="submitted"
    message="Não foi possível validar o código. Confira os 6 caracteres informados."
    alertClass="alert-danger"
  ></page-alert>

  <mat-form-field>
    <mat-label>Código</mat-label>
    <input matInput formControlName="code" placeholder="Código de atendimento" required />
    <mat-error *ngIf="paymentCodeForm.get('code')?.hasError('required')"> O código é obrigatório </mat-error>
    <mat-error *ngIf="paymentCodeForm.get('code')?.hasError('pattern')"> O código deve ter 6 caracteres alfanuméricos </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="codeIsMatch()">Verificar</button>
  <button mat-button color="warn" [mat-dialog-close]="false">Cancelar</button>
</mat-dialog-actions>
